import { render, staticRenderFns } from "./PromotedBuyBoxNew.vue?vue&type=template&id=78b57d5e&scoped=true"
import script from "./PromotedBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotedBuyBoxNew.vue?vue&type=style&index=0&id=78b57d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b57d5e",
  null
  
)

export default component.exports